import { api } from "./api";

export const obtenerTodosLosGeneros = async () => {
  const { data } = await api.get("/generos/all");
  return data;
};

export const crearGenero = async (generoDTO) => {
  const { data } = await api.post("/generos/create", generoDTO);
  return data;
};
